var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sucessBg"
  }, [_c('div', {
    staticClass: "success"
  }, [_vm._m(0), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mobile ? $t("gnyxu87", "手机端登录确认") : $t("sgopwj7", "电脑端登录确认")) + " ")]), _c('div', {
    staticStyle: {
      "color": "#999999",
      "font-size": "12px",
      "margin-top": "5px"
    }
  }, [_vm._v(` ${$t("ych8ah5", "您正在登录")}` + _vm._s(_vm.title) + " ")]), _vm.mobile ? _c('div', {
    staticClass: "button_con"
  }, [_c('Button', {
    staticClass: "buttons",
    attrs: {
      "long": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_vm._v($t("frupio4", "确认登录"))]), _c('Button', {
    staticClass: "buttons textBtn",
    attrs: {
      "long": "",
      "type": "text"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.cancle.apply(null, arguments);
      }
    }
  }, [_vm._v($t("b1a8to4", "取消登录"))])], 1) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v($t("huqs37b", "登录成功 请稍后..."))]), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticStyle: {
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v($t("7d7j0ba", "杭州绿云科技有限公司"))]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(` ${$t("ilc7781j", "浙ICP备11052993号-2 浙公网安备33010602007191号 Copyright © 2010-")}` + _vm._s(_vm.currentYear) + " ")]), _c('div', [_vm._v("Hangzhou GreenCloud Tech Co., Ltd. All Rights Reserved.")])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/phoneBg.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };